export default __webpack_public_path__ + "static/media/more11.44cc80e7.jpeg";